import React from "react";
import { Link, useHistory } from "react-router-dom";
import { func, string, bool } from "prop-types";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { BONUS_PRICE } from "../../constants/defaults";

const LoginToaster = ({
  hideToaster,
  message,
  firstName,
  lastName,
  closeSignupModal,
  isFromDrugPage
}) => {
  const { t, i18n } = useTranslation();
  let type = 1;
  if (message === "UserExists,VerificationRequired") {
    type = 2;
  } else if (message === "UserExists,BonusApplied") {
    type = 3;
  }
  const history = useHistory();
  const handleClick = () => {
    isFromDrugPage ? closeSignupModal() : history.push("/");
  };
  return (
    <div>
      <div className="bgshowModal" onClick={hideToaster}></div>
      <div className="tosterMessage">
        <div className="tosterContent">
          <h2>
            {type === 1
              ? `${t("Good news")}!`
              : "Looks like you already have a Singlecare account."}
          </h2>
          {type === 1 ? (
            <div>
              <p>{t("An account already exists for this email address.")}</p>
              <Link to={_.withLocale(i18n.language, "/login")}>
                {t("Log in")}.
              </Link>
            </div>
          ) : type === 2 ? (
            <div>
              <p>
                To log in, you’ll need to reset your password. <br />
                Please check your inbox for an email explaining how to reset
                your password.
              </p>
              <a onClick={handleClick}>Close</a>
            </div>
          ) : (
            <div>
              <p className="padding0">
                ${BONUS_PRICE} in bonus savings has just been added to {firstName}{" "}
                {lastName}’s account.
              </p>
              <br />
              <p className="padding0">
                Your bonus savings will automatically apply when you fill your
                next eligible prescription!
              </p>
              <Link to="/login">Log in.</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

LoginToaster.propTypes = {
  hideToaster: func,
  message: string,
  firstName: string,
  lastName: string,
  closeSignupModal: func,
  isFromDrugPage: bool
};

export default LoginToaster;
